@for (category of categories(); track $index) {
  <div class="category">
    <h4 class="name" [title]="category.tooltip">
      {{ category.name }}
    </h4>
    <button
      class="close"
      type="button"
      puButton
      uiType="quaternary"
      size="m"
      [disabled]="!canRemove()"
      [onlyIcon]="true">
      <pu-icon (click)="remove($index)" iconName="remove" size="16"> </pu-icon>
    </button>
  </div>
} @empty {
  @for (i of array; track $index) {
    <div class="pp-shimmer category"></div>
  }
}
